module.exports = __webpack_public_path__ + "static/media/cohere.1582fb8d.svg";